<template>
  <div v-show="showPopup" class="user-popup user-popup__logged pt-1 px-0">
    <div class="col-12 py-2">
      <a :href="dictionary.url.user.orders" class="user-popup__logged-link justify-content-start px-2 pt-1"
         :title="dictionary.siteHeader.login.orders">
        <div class="col-2 d-flex align-items-center justify-content-center mx-1">
          <img
            :src="`/nuxt-assets/images/icons/orders.svg`"
            class="justify-content-start"
            width="15"
            height="35"
            :alt="dictionary.siteHeader.login.orders"
          />
        </div>
        {{ dictionary.siteHeader.login.orders }}
      </a>
    </div>

    <div class="col-12 py-2">
      <a
        :href="dictionary.url.user.feedback"
        class="user-popup__logged-link justify-content-start px-2 pt-1"
        :title="dictionary.siteHeader.login.myRatings"
      >
        <div class="col-2 d-flex align-items-center justify-content-center mx-1">
          <img
            :src="`/nuxt-assets/images/icons/star.svg`"
            class="justify-content-start filter-grayscale"
            width="16"
            :alt="dictionary.siteHeader.login.myRatings"
          />
        </div>

        {{ dictionary.siteHeader.login.myRatings }}
      </a>
    </div>

    <div class="col-12 py-2">
      <a :href="dictionary.url.user.profile" class="user-popup__logged-link justify-content-start px-2 pt-1"
         :title="dictionary.siteHeader.login.userInfo">
        <div class="col-2 d-flex align-items-center justify-content-center mx-1">
          <img
            :src="`/nuxt-assets/images/icons/user.svg`"
            class="justify-content-start"
            width="16"
            :alt="dictionary.siteHeader.login.userInfo"
          />
        </div>
        {{ dictionary.siteHeader.login.userInfo }}
      </a>
    </div>

    <div class="col-12 py-2">
      <a
        :href="dictionary.url.user.myFavorite"
        class="user-popup__logged-link justify-content-start px-2 pt-1"
        :title="dictionary.siteHeader.login.favoriteProducts"
      >
        <div class="col-2 d-flex align-items-center justify-content-center mx-1">
          <img
            :src="`/nuxt-assets/images/icons/heart-black.svg`"
            class="justify-content-start"
            width="17"
            :alt="dictionary.siteHeader.login.favoriteProducts"
          />
        </div>
        {{ dictionary.siteHeader.login.favoriteProducts }}
      </a>
    </div>

    <div class="col-12 py-2" v-if="false">
      <a
        :href="dictionary.url.user.profile"
        class="user-popup__logged-link justify-content-start px-2 pt-1"
        :title="dictionary.siteHeader.login.reviewClub"
      >
        <div class="col-2 d-flex align-items-center justify-content-center mx-1">
          <img
            :src="`/nuxt-assets/images/icons/review-club.svg`"
            class="justify-content-start"
            width="11"
            :alt="dictionary.siteHeader.login.reviewClub"
          />
        </div>
        {{ dictionary.siteHeader.login.reviewClub }}
      </a>
    </div>

    <div class="col-12 pt-3">
      <form method="post" ref="formLogin" :action="dictionary.url.user.logout">
        <input type="hidden" name="redirect_uri" :value="redirectUri" />
        <input
          type="submit"
          name="logout"
          :value="dictionary.siteHeader.login.logout"
          class="user-popup__logged-pink-link mx-auto d-block"
          :title="dictionary.siteHeader.login.logout"
          @click.prevent="logout"
        />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dictionary: {
      type: Object,
      required: true,
    },
    showPopup: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    redirectUri() {
      if( typeof window !== "undefined" ) {
        return window.location.href
      }
      return ""
    },
  },
  methods: {
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },

    logout() {
      this.deleteCookie("accessToken")
      this.$refs.formLogin.submit()
    }
  }
}
</script>

<style lang="scss">
$primary: #e6007e;

.user-popup {
  &__logged {
    min-width: 187px;
  }

  &__logged-link {
    color: #333333;
    text-decoration: none;
    font-size: 14px;
    display: flex;
    white-space: nowrap;
    align-items: center;
    flex-direction: row !important;

    &:hover {
      color: #333333;
      text-decoration: underline;
    }
  }

  &__logged-pink-link {
    font-size: 14px;
    color: $primary;
    background: transparent;
    border: 0;
    padding: 0;
      cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
